import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { withStyles } from "@mui/styles";
import React, { Component } from "react";
import CtTxt from "./CustomTool/CtTxt";
import CtTxtPWD from "./CustomTool/CtTxtPWD";
import CtBtn from "./CustomTool/CtBtn";
import image from "../images/image.png";
import { connect } from "react-redux";
import {
  mapSetActiveMenu_MenuVisibility_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { Link, useNavigate } from "react-router-dom";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import {
  setMenuPrivileges,
  setMenuPrivilegesToFalse,
} from "../SystemUtility/MenuUtility";
import { fetchUser } from "./API";
import {
  ListAlt,
  Assessment,
  Business,
  Hail,
  Hiking,
  PostAdd,
  AccountCircle,
  ReceiptOutlined,
} from "@mui/icons-material";
import Sign_Up from "./Sign_Up";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";

const useStyles = (theme) => ({
  card1: {
    // height: "420px",
    // width: "420px",
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
  },
  forget: {
    margin: "10px 0",
    fontWeight: "400",
    color: "#05699d",
    float: "right",
  },
  submit: {
    color: "white",
    backgroundColor: "#05699d",
  },
});

class Login extends Component {
  state = {
    formData: {
      txtUserId: "",
      txtPassword: "",
    },
    ARD: null,
  };

  //#region Component
  componentDidMount() {
    // this.props.setTitle();
    document.title = "RiTe Account : Login";
    this.props.setActiveMenu("/");
    this.clearLocalStorage();
    setMenuPrivilegesToFalse(
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
    document.getElementById("txtUserId").focus();
  }
  //#endregion

  //#region Handle
  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };
  //#endregion

  //#region Function
  setLoginDetailToLocalStorage = (logInID, UserName, bint_ci) => {
    // console.log('logInID, UserName', logInID, UserName)
    this.clearLocalStorage();
    localStorage.setItem("logInID", logInID);
    localStorage.setItem("logInLinkText", "Log Out");
    localStorage.setItem("UserName", UserName);
    localStorage.setItem("CI", bint_ci);
  };

  clearLocalStorage = () => {
    localStorage.removeItem("logInID");
    localStorage.removeItem("UserName");
    localStorage.setItem("logInLinkText", "Log In");
    localStorage.removeItem("FullACY");
    localStorage.removeItem("ACY");
    localStorage.removeItem("CompanyName");
    localStorage.removeItem("acid");
    localStorage.removeItem("CompStateCode");
    localStorage.removeItem("CI");
    localStorage.removeItem("defaultsettings");
  };

  navigateTo = (link) => {
    this.props.navigate("/" + link);
  };

  validateInput = (index = null) => {
    let result = false;
    if (
      (index === null || index === 0) &&
      this.state.formData.txtUserId.length <= 0
    ) {
      this.props.toastErrorMsg("Enter User ID", "txtUserId");
    } else if (
      (index === null || index === 1) &&
      this.state.formData.txtPassword.length <= 0
    ) {
      this.props.toastErrorMsg("Enter Password", "txtPassword");
    } else {
      result = true;
    }
    return result;
  };

  verifyLogin = () => {
    if (this.validateInput()) {
      this.props.notifyProcessing();

      const reqData = {
        Op: "VerifyUser",
        vac_userid: this.state.formData.txtUserId,
        vac_password: this.state.formData.txtPassword,
      };
      fetchUser(reqData)
        .then((res) => {
          this.setState({ res: res.data });
          this.props.closeUpdateProcessing(res.data.msgType, res.data.message);
          // console.log(this.state.res);
          if (res.data.msgType === "success") {
            this.setLoginDetailToLocalStorage(
              this.state.formData.txtUserId,
              res.data.vac_username,
              res.data.bint_ci
            );
            if (res.data.vac_privileges && res.data.vac_privileges.length > 0) {
              // console.log("this.props",this.props);
              setMenuPrivileges(
                res.data.vac_privileges,
                this.props.setSubMenu_Master_Entry,
                this.props.setUserPrivileges
              );
            }
            this.navigateTo("Dashboard");
          }
          // set local storage of UserType, USerID.
        })
        .catch((err) => {
          this.props.updateProcessing(
            "error",
            "Unknown error occured in VerifyUser.\n\n" + err
          );
        });
    }
  };

  OnSingup = () => {
    // console.log("faizan");
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          // labelAgree='Set'
          // alertMessage={<SignUp />}
          alertMessage={<Sign_Up />}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );

      this.setState({ ARD }, () => {});
    });
  };

  OnForgotPassword = () => {
    this.props.toastErrorMsg("Development Remain..");
  };
  //#endregion Function

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Grid
          className={classes.root}
          container
          display="flex"
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          minheight="90vh"
          // spacing={2}
        >
          {/* <Grid item sx="auto" display="flex" justifyContent="space-between" flexDirection="row"> */}
          <Grid item xs={12} md={8}></Grid>
          <Grid item xs={12} md={4}>
            <Container className={classes.root}>
              <Card className={classes.card1}>
                <CardContent>
                  <Typography
                    fontSize="30px"
                    display="flex"
                    justifyContent="flex-start"
                    fontWeight="600"
                    color="#05699d"
                    // marginBottom="20px"
                  >
                    Welcome Back!
                  </Typography>
                  <Typography
                    fontSize="18px"
                    display="flex"
                    justifyContent="flex-start"
                    fontWeight="300"
                    color="#575759"
                    marginBottom="20px"
                  >
                    Login to continue
                  </Typography>
                  <form>
                    <CtTxt
                      id="txtUserId"
                      label="User ID"
                      variant="outlined"
                      handleOnChange={this.handleOnChange}
                      value={this.state.formData.txtUserId}
                      fullWidth={true}
                      onKeyDown={this.props.onKeyDown}
                      maxLength="50"
                    />
                    <CtTxtPWD
                      id="txtPassword"
                      label="Password"
                      variant="outlined"
                      handleOnChange={this.handleOnChange}
                      value={this.state.formData.txtPassword}
                      type="password"
                      fullWidth={true}
                      formcontrolStyle={{ marginTop: "20px" }}
                      onKeyDown={this.props.onKeyDown}
                      defaultAction={this.verifyLogin}
                      validateInput={this.validateInput}
                      maxLength="50"
                    />
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      spacing={3}
                      marginTop={0}
                    >
                      <Grid item>
                        <CtBtn
                          variant="contained"
                          //   className={classes.submit}
                          width="auto"
                          onClick={this.verifyLogin}
                          label="Login"
                          bgColor="#05699d"
                        />
                      </Grid>
                      <Grid item>
                        <CtBtn
                          variant="contained"
                          width="auto"
                          label="Sign Up"
                          bgColor="#05699d"
                          onClick={this.OnSingup}
                        />
                      </Grid>
                      <Grid item>
                        <CtBtn
                          variant="text"
                          label="Forgot Password?"
                          fontColor="#05699d"
                          // className={classes.forget}
                          //   onClick={() => this.navigateTo("Forgotpass")}
                          onClick={this.OnForgotPassword}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      // marginTop={2}
                      // spacing={2}
                    >
                      <Grid item>
                        <Typography
                          fontSize="15px"
                          display="flex"
                          justifyContent="center"
                          fontWeight="300"
                          color="#575759"
                          marginTop="10px"
                        >
                          Copyright @ 2023
                        </Typography>
                        <Typography
                          fontSize="15px"
                          display="flex"
                          justifyContent="center"
                          fontWeight="300"
                          color="#575759"
                          marginBottom="15px"
                        >
                          <span style={{ marginRight: "4px" }}>
                            Developed By
                          </span>
                          {/* Developed By{" "} */}
                          <a
                            href="https://ravitechworld.com/"
                            underline="hover"
                            target="_blank"
                          >
                            RavitechWorld
                          </a>
                        </Typography>
                      </Grid>
                    </Grid>
                  </form>
                </CardContent>
              </Card>
            </Container>
          </Grid>
          {/* </Grid> */}
          <Grid item>
            <Box
              display={{ xs: "none" }}
              style={{ textAlign: "center", justifyContent: "center" }}
            >
              {this.state.ARD}
            </Box>
          </Grid>
        </Grid>
      </div>
    );
  }
}
function WithNavigate(props) {
  let navigate = useNavigate();
  return <Login {...props} navigate={navigate} />;
}
export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(withStyles(useStyles)(HoCtToastContainer(WithNavigate)));
